module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.isAdmin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('coordinator-commission-report')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('monthly-breakdown-report')], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isAdmin) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('completed-jobs-report')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('carrier-income-report')], 1)]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('system-users-report')], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-056c1f9d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Reports.vue
// module id = 920
// module chunks = 0